import { Navigate, Outlet } from 'react-router-dom';
import { MODULE_ROUTE } from './module-router';
import CookieUtils from '../utils/cookie-utils';

export const ProtectedRoutes = () => {
    const token = CookieUtils.getCurrentUser().access_token ?? "";
    if (token === "") {
        return <Navigate to={MODULE_ROUTE.LOGIN} replace />;
    }

    return <Outlet />;
};
